import * as Apis from "@/utils/apisRequest";
import * as App from "@/utils/appRequest";

export default {

	//用于显示用户的消息列表
	//地址：http://api.stock-ring.com/v1/notify/list
	// 请求方式：GET
	// 入参：
	/*	user_id	query参数	integer	是	用户id	12
		compare_to	query参数	integer	否	翻页时间戳
		page	query参数	integer	否	请求页码	1*/
	async getMesList(opt) {
		let res = await Apis.get({
			url: "/v1/notify/list",
			params: {
				...opt
			}
		});
		return res;
	},


	//用于显示用户的对话列表
	//参数
	/*
	opposite_user	query参数	integer	是	对话的用户id	7
	compare_to	query参数	integer	否	翻页时间戳	1585276525 第一次请求paging 传 0即可
	*/
	async getMesData(opt) {
		let res = await Apis.get({
			url: "/Notify/conversationList",
			params: {
				...opt,
				source: "pc",
				appversion: "11.8.0"
			}
		});
		return res;
	},



	//发送消息
	//参数
	async SendMes(opt) {
		let res = await Apis.post({
			url: "/PrivateLetter/send",
			params: {
				...opt
			}
		});
		return res;
	},


	// 获取TIM签名
	async getIVToken(opt) {
		let res = await App.get({
			url: "/v2/getTLSSigAPIv2",
			params: {
				...opt
			}
		});
		return res;
	}


};
